export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";